import React from 'react';

const PieChartIcon = ({ size }: { size: number }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height="62"
      fill="none"
      viewBox="0 0 80 56"
    >
      <path fill="#3B82F6" d="M40 28V8a20 20 0 0 1 11.76 36.18z"></path>
      <path fill="#818CF8" d="m40 28 11.76 16.18a20 20 0 0 1-29.86-7.66z"></path>
      <path fill="#38BDF8" d="m40 28-18.1 8.52a20 20 0 0 1 4.41-23.1z"></path>
      <path fill="#A5B4FC" d="M40 28 26.31 13.42A20 20 0 0 1 40 8z"></path>
    </svg>
  );
};

export default PieChartIcon;
